(function () {
  var dateValue = '';

  function pickupEls()       { return document.querySelectorAll('[data-cart-pickup-date]'); }
  function checkoutBtns()    { return document.querySelectorAll('.cart__checkout-button'); }
  function cartForms()       { return document.querySelectorAll('#cart-form'); }
  function acceleratedBtns() { return document.querySelectorAll('[data-balloon-cart] .additional-checkout-buttons'); }

  function blockCheckout() {
    checkoutBtns().forEach(function (btn) {
      btn.disabled = true;
      btn.setAttribute('data-pickup-blocked', '');
    });
    acceleratedBtns().forEach(function (acc) {
      acc.classList.add('additional-checkout-buttons--blocked');
      acc.setAttribute('inert', '');
      acc.setAttribute('aria-hidden', 'true');
    });
  }

  function unblockCheckout() {
    checkoutBtns().forEach(function (btn) {
      btn.disabled = false;
      btn.removeAttribute('data-pickup-blocked');
    });
    acceleratedBtns().forEach(function (acc) {
      acc.classList.remove('additional-checkout-buttons--blocked');
      acc.removeAttribute('inert');
      acc.removeAttribute('aria-hidden');
    });
  }

  function setMin(input) {
    var d = new Date();
    input.min =
      d.getFullYear() + '-' +
      String(d.getMonth() + 1).padStart(2, '0') + '-' +
      String(d.getDate()).padStart(2, '0');
  }

  function applyState(el) {
    var input = el.querySelector('.cart-pickup-date__input');
    var warning = el.querySelector('.cart-pickup-date__warning');
    var confirmed = el.querySelector('.cart-pickup-date__confirmed');
    if (!input) return;

    input.classList.remove('cart-pickup-date__input--required');
    if (warning) warning.setAttribute('hidden', '');
    if (dateValue) {
      if (confirmed) confirmed.removeAttribute('hidden');
    } else {
      if (confirmed) confirmed.setAttribute('hidden', '');
    }
  }

  function applyAll() {
    pickupEls().forEach(applyState);
    if (pickupEls().length === 0) {
      unblockCheckout();
    } else if (dateValue) {
      unblockCheckout();
    } else {
      blockCheckout();
    }
  }

  var saveTimer;
  function save(date) {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Pickup Date': date } }),
      }).catch(function () {});
    }, 400);
  }

  function bindInput(el) {
    var input = el.querySelector('.cart-pickup-date__input');
    if (!input) return;

    setMin(input);

    if (!input.dataset.pickupBound) {
      input.dataset.pickupBound = '1';
      input.addEventListener('change', function () {
        dateValue = input.value || '';
        pickupEls().forEach(function (other) {
          var otherInput = other.querySelector('.cart-pickup-date__input');
          if (otherInput && otherInput !== input) otherInput.value = dateValue;
        });
        applyAll();
        save(input.value);
      });
    }

    if (input.value && !dateValue) dateValue = input.value;
    if (dateValue && input.value !== dateValue) input.value = dateValue;
  }

  function bindForms() {
    cartForms().forEach(function (form) {
      if (form.dataset.pickupSubmitBound) return;
      form.dataset.pickupSubmitBound = '1';
      form.addEventListener('submit', function (e) {
        var els = pickupEls();
        if (!els.length) return;
        if (!dateValue) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var firstEl = els[0];
          var input = firstEl.querySelector('.cart-pickup-date__input');
          var warning = firstEl.querySelector('.cart-pickup-date__warning');
          if (input) {
            input.classList.add('cart-pickup-date__input--required');
            if (warning) warning.removeAttribute('hidden');
            firstEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            input.focus();
          }
        }
      });
    });
  }

  function refresh() {
    bindForms();
    pickupEls().forEach(bindInput);
    applyAll();
  }

  // cart:update is dispatched synchronously BEFORE morphSection runs
  // (component-cart-items.js:159-167), so defer to the next tick.
  document.addEventListener('cart:update', function () {
    setTimeout(refresh, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
